import React from 'react';
import { Image, Segment } from 'semantic-ui-react';
export default {
  React,
  Image,
  Segment
};